import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, onFocus, ...props }, ref) => {
  // UX fix for number inputs: when a field already contains "0" (the common
  // default), typing a digit produces "01"/"02"/... instead of replacing.
  // Auto-selecting the content on focus makes the next keystroke overwrite it,
  // matching how spreadsheets behave. We preserve any caller-provided onFocus.
  const handleFocus = React.useCallback(
    (e) => {
      if (type === "number") {
        // Some browsers (Safari) throw on .select() for number inputs.
        // setSelectionRange would be ideal but isn't supported on type=number.
        // .select() works fine on Chrome/Firefox/Edge. Wrap in try to be safe.
        try { e.target.select(); } catch { /* noop */ }
      }
      onFocus?.(e);
    },
    [type, onFocus]
  );

  return (
    <input
      type={type}
      onFocus={handleFocus}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
